import React, { useState, useEffect } from "react";
import "../styles/stocklist.scss";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Divider,
  Tag,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import StockSingleCard from "./stockSingleCard";
import StockVariantCard from "./stockVariantCard";
import { MdErrorOutline } from "react-icons/md";

const StockListCard = ({ product }) => {
  const [productState, setProductState] = useState({});
  const [filteredVariant, setFilteredVariant] = useState([]);

  useEffect(() => {
    if (product.productId) {
      setProductState({ ...product });
    }

    if (product.productType !== "Single") {
      const filterWarehouse = product.warehouseStocks.filter(
        (item) => item.productVariant
      );
      const sortProduct = filterWarehouse.sort((a, b) =>
        a.productVariant.name > b.productVariant.name ? 1 : -1
      );
      setFilteredVariant(sortProduct);
    }
  }, [product]);

  return (
    <Accordion
      allowToggle
      className="accordian-container"
      key={product?.productId || 1}>
      <AccordionItem mb={2}>
        <h2>
          <AccordionButton>
            <Box flex="1" textAlign="left" display="flex" alignItems="center">
              {productState.productName}
              <Tag ml="4" borderRadius="full" className="variant-capsule">
                {product.productType}
              </Tag>
            </Box>
            <Flex justifyContent="flex-end">
              {product.productType === "Single" ? (
                <>
                  {product?.warehouseStocks[0]?.availableStock > 0
                    ? "Ready Stock"
                    : "Out of Stock"}{" "}
                  ({product.warehouseStocks[0].availableStock})
                </>
              ) : (
                <Flex alignItems="center">
                  {product.variantCount.outOfStock > 0 && (
                    <>
                      <Icon as={MdErrorOutline} color="#FF5959" mr="2" />
                      <Text mr="6">
                        {product.variantCount.outOfStock} Variant Out of Stock
                      </Text>
                    </>
                  )}
                  {product.variantCount.lowStock > 0 && (
                    <>
                      <Icon as={MdErrorOutline} color="#FFA959" mr="2" />
                      <Text>{product.variantCount.lowStock} Variant Low</Text>
                    </>
                  )}
                </Flex>
              )}
            </Flex>
            <AccordionIcon boxSize={10} />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} className="expand-accordian-container">
          {product.productType === "Single" ? (
            <StockSingleCard
              product={product}
            />
          ) : (
            <>
              {filteredVariant.map((variant, index) => (
                <>
                  <StockVariantCard
                    variant={variant}
                  />

                  {index !== filteredVariant.length - 1 && (
                    <Divider borderColor="#C4C4C4" />
                  )}
                </>
              ))}
            </>
          )}
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};

export default StockListCard;
